import { render, staticRenderFns } from "./wappPrivado.vue?vue&type=template&id=248a6172&scoped=true"
import script from "./wappPrivado.vue?vue&type=script&lang=js"
export * from "./wappPrivado.vue?vue&type=script&lang=js"
import style0 from "./wappPrivado.vue?vue&type=style&index=0&id=248a6172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a6172",
  null
  
)

export default component.exports